<template lang="pug">
.subscribe-modal
  edit-member-modal(v-if="openEditMemberDialog" :open.sync="openEditMemberDialog" :company="company" :count="totalAllowedMember")
  edit-form-modal(v-if="openEditFormDialog" :open.sync="openEditFormDialog" :company="company" :count="totalAllowedForm")
  y-dialog(v-model="dialog" :max-width="(step == 1 || step == 2)? '600px' : '400px'" persistent scrollable)
    v-card
      v-card-title.px-4
        span {{ windowTitle }}
        v-spacer
        v-progress-circular(:value="currentProgress" size='24' color="primary")
      v-divider
      v-card-text.px-4
        v-window(v-model="step")
          v-window-item(:value="0")
            v-container(v-if="authMember.id === company.primary_owner")
              div
                p If you subscribe now, you can enjoy these benefits:
                div.mb-1 👉 Benefit 1: Get an ecommerce site with your own custom domain like coverscloset.com just by uploading product - Yezza Store
                div.mb-1 👉 Benefit 2: Get a WhatsApp link with your own custom domain like&nbsp;
                  a(href="https://wasap.coverscloset.com/iwant" style="text-decoration: none" target="_blank") wasap.coverscloset.com/iwant
                  | &nbsp;- Yezza Smartlink
                div.mb-1 👉 Benefit 3: Get your own domain “www.example.com” for FREE
                div.mb-1 👉 Benefit 4: Get RM200 ~ RM600 worth of discount
            v-container(v-else)
              p Please contact your admin and notify them to renew subscription.

          v-window-item(:value="1")
            div.mt-4.font-weight-bold Your current account
            v-card
              v-simple-table.mt-4
                template(v-slot:default)
                  tbody
                    tr
                      td.font-weight-bold(:class="isValidMemberCount ? '' : 'red--text' ") {{ company.active_member_count }} active salespersons/agents
                      td.text-right
                        v-btn(v-if="!isValidMemberCount" icon @click="openEditMemberDialog = true")
                          v-icon mdi-square-edit-outline
                        v-icon.mr-2(v-else color="green lighten-1" @click="openEditMemberDialog = true") mdi-check-circle
                    tr
                      td.font-weight-bold(:class="isValidFormCount ? '' : 'red--text' ") {{ company.published_form_count }} published forms
                      td.text-right
                        v-btn(v-if="!isValidFormCount" icon @click="openEditFormDialog = true")
                          v-icon mdi-square-edit-outline
                        v-icon.mr-2(v-else color="green lighten-1" @click="openEditFormDialog = true") mdi-check-circle

            div.mt-6.title.font-weight-bold.black--text.text-center Suitable plan for you
            h1.display-2.text-center.font-weight-bold {{ totalPrice }}
              span(v-if="extraPrice")  + {{ extraPrice }}
            h3.subtitle.text-center(v-if="totalPrice != 37") Normal Price:&nbsp;
              span(v-if="extraPrice" style="text-decoration: line-through;") RM {{ totalPriceNormal }} + {{ extraPriceNormal }}
              span(v-else style="text-decoration: line-through;") RM {{ totalPriceNormal }}
            div.caption.text-center.font-medium RM for 12-months
            div.mt-4.mb-2.font-weight-bold.text-center Change plan
            v-card.px-2.mb-4(outlined)
              v-list
                template(v-for="(plan, index) in plans")
                  v-list-item.px-0
                    v-list-item-content
                      v-row(align="center")
                        v-col.py-0.pr-0
                          p.mb-0.font-weight-bold.mr-2.d-inline(style="font-size: 16px") {{ plan.name }}
                          v-chip.py-1.px-2.d-inline(color="primary" small outlined) RM{{ plan.price }}
                        v-col.py-0.shrink
                          v-btn(v-if="plan.selected" small color="primary" depressed width="60")
                            v-icon mdi-check
                          v-btn(v-else outlined small color="primary" width="60" @click="selectPlan(plan)") Select
                      v-list-item-subtitle {{ plan.detail }}
                      v-list-item-subtitle.mt-1.caption.font-weight-bold(v-if="plan.name == 'Personal'") {{ plan.note }}

            div.mb-2.font-weight-bold.text-center Add-ons
            v-card.pa-2.mb-4(outlined)
              v-list-item.px-0.my-n2(v-if="formItems.length > 0")
                v-list-item-content
                  v-list-item-title.font-weight-bold Form
                  div.caption + RM30 each for 12-months (save RM6)
                v-list-item-action
                  div(style="width: 80px;")
                    v-select(v-model="formAddOnCount" hide-details outlined dense :items="formItems")
              v-list-item.px-0.my-n2
                v-list-item-content
                  v-list-item-title.font-weight-bold Salesperson
                  div.caption + RM100 each for 12-months (save RM20)
                v-list-item-action
                  div(v-if="memberItems.length > 0" style="width: 80px;")
                    v-select(v-model="memberAddOnCount" hide-details outlined dense :items="memberItems")
                  v-layout(v-else)
                    v-btn.my-auto(icon small @click="memberAddOnCount--" :disabled="memberAddOnCount < 1")
                      v-icon(color="primary") mdi-minus-circle
                    span.my-auto.text-center.colbox {{ memberAddOnCount }}
                    v-btn.my-auto(icon small @click="memberAddOnCount++")
                      v-icon(color="primary") mdi-plus-circle

          v-window-item(:value="2")
            //- v-select.mx-4.mt-6.mb-n3(v-model='accountType' label="Account type" :items="accountTypes" item-text="name" item-value="id" outlined)
            validate-project-sme(v-if="accountType == 'business'" @verified="handleVerification" :proceed.sync="proceed" :company="company")
            validate-project-b40(v-if="accountType == 'personal'" @verified="handleVerification" :proceed.sync="proceed" :company="company")
          v-window-item.text-center(:value="3")
            div.mt-6.title.font-weight-bold.black--text {{ selectedPlan.name }} Plan
            h1.display-2.text-center.font-weight-bold {{ totalPrice }}
              span(v-if="extraPrice")  + {{ extraPrice }}
            div.caption.text-center.font-medium RM for 12-months
            .extra.mt-2(v-if="formAddOnCount || memberAddOnCount")
              div.black--text Included:
              div.body-2(v-if="formAddOnCount") {{ formAddOnCount }} extra form(s)
              div.body-2(v-if="memberAddOnCount") {{ memberAddOnCount }} extra member(s)
            .online-payment.mt-4
              div.title.font-weight-bold.mb-3 Choose bank for payment
              v-card.mb-12
                v-list.pa-0
                  v-list-item-group(v-model='selectedBankIndex', color='primary')
                    template(v-for='(bank, index) in banks')
                      v-divider(v-if="index != 0")
                      v-list-item(:key='bank.code' v-slot:default='{ active, toggle }')
                        v-list-item-icon.my-3
                          v-card
                            v-img(:src="bank.image ? bank.image : require('@/assets/image_placeholder.png')" width=24, height=24)
                        v-list-item-content {{ bank.name }}
                        v-list-item-action.my-0(v-show="active")
                          v-btn(icon)
                            v-icon(color='success') mdi-check
          v-window-item(:value="4")
            v-container
              div Thank you for giving us the opportunity to help you grow further and bigger. Let’s do this together.
          v-window-item(:value="5")
            v-container
              div The payment did not go through, please try again.
              v-btn.mt-3.block(color="accent" @click="retryPayment" :loading="retryPaymentLoading") Retry Payment
      v-divider
      v-card-actions(v-if="authMember.id === company.primary_owner")
        v-spacer
        template(v-if="step === 0")
          v-btn(v-if="skippable" text @click="dialog = false") Subscribe later
        v-btn(v-else-if="step !== 4" text @click="backStep") Back
        v-btn(v-if="step === 3" color="accent" @click="nextStep" depressed :disabled="!banks[selectedBankIndex]" :loading="isLoading") Pay
        v-btn(v-else-if="step === 4" @click="finish()" color="accent" depressed) Finish
        v-btn(v-else-if="step !== 5" color="accent" @click="nextStep" depressed) Next

</template>

<script>
import { mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import SubscribeLaterModal from './SubscribeLaterModal'
import EditMemberModal from './EditMemberModal'
import EditFormModal from './EditFormModal'
import ValidateProjectB40 from '@/views/signup/components/ValidateProjectB40'
import ValidateProjectSme from '@/views/signup/components/ValidateProjectSme'

export default {
  name: "Subscribe1010Modal",
  components: { SubscribeLaterModal, CardList, EditMemberModal, EditFormModal, ValidateProjectB40, ValidateProjectSme },
  props: ['open', 'company', 'skippable', 'payment'],
  data: (v) => ({
    accountType: 'personal',
    subscribeLater: false,
    openEditMemberDialog: false,
    openEditFormDialog: false,
    step: 0,
    proceed: 0,
    steps: [
      { title: '🔟🔟 Yezza Combo'},
      { title: 'Choose your plan'},
      { title: 'Application form'},
      { title: 'Confirm your subscription'},
      { title: 'Subscription Successful!'},
      { title: 'Payment Unsuccessful'}
    ],
    plans: [
      { name: 'Personal', value: 1, detail: '1 forms, 1 salesperson', form_count: 1, member_count: 1, price: 400, normal_price: 444, max: { member: 4, form: 4 }, selected: false },
      { name: 'Business', value: 2, detail: '10 forms, 5 salesperson', form_count: 10, member_count: 5, price: 1500, normal_price: 1764, max: { member: 9, form: 14 }, selected: false },
      { name: 'Intelligence', value: 3, detail: 'Unlimited forms, 10 salesperson', form_count: 0, member_count: 10, price: 2500, normal_price: 3564, max: { member: null, form: null }, selected: false }
    ],
    selectedPlan: null,
    form: {
      company: v.company.id,
      plan: null
    },
    accountTypes: [
        {
        name: 'Please Select',
        id: 'select'
      },
      {
        name: 'Company',
        id: 'business'
      },
     {
        name: 'Individual',
        id: 'personal'
      }
    ],
    formAddOnCount: 0,
    memberAddOnCount: 0,
    bankImages: [
      { name: '2C2P Payment Gateway', image: require('@/assets/images/fpx/2c2p.png') },
      { name: 'Affin Bank', image: require('@/assets/images/fpx/ABB0233.png') },
      { name: 'Alliance Bank', image: require('@/assets/images/fpx/ABMB0212.png') },
      { name: 'Alliance Bank Malaysia', image: require('@/assets/images/fpx/ABMB0212.png') },
      { name: 'AGRONet', image: require('@/assets/images/fpx/AGRO01.png') },
      { name: 'AmBank', image: require('@/assets/images/fpx/AMBB0209.png') },
      { name: 'CIMB Clicks', image: require('@/assets/images/fpx/BCBB0235.png') },
      { name: 'CIMB', image: require('@/assets/images/fpx/BCBB0235.png') },
      { name: 'Bank Islam', image: require('@/assets/images/fpx/BIMB0340.png') },
      { name: 'Bank Islam Malaysia', image: require('@/assets/images/fpx/BIMB0340.png') },
      { name: 'Bank Rakyat', image: require('@/assets/images/fpx/BKRM0602.png') },
      { name: 'Bank Muamalat', image: require('@/assets/images/fpx/BMMB0341.png') },
      { name: 'Bank Muamalat Malaysia', image: require('@/assets/images/fpx/BMMB0341.png') },
      { name: 'BSN', image: require('@/assets/images/fpx/BSN0601.png') },
      { name: 'Bank Simpanan Nasional', image: require('@/assets/images/fpx/BSN0601.png') },
      { name: 'Hong Leong Bank', image: require('@/assets/images/fpx/HLB0224.png') },
      { name: 'HSBC Bank', image: require('@/assets/images/fpx/HSBC0223.png') },
      { name: 'HSBC', image: require('@/assets/images/fpx/HSBC0223.png') },
      { name: 'KFH', image: require('@/assets/images/fpx/KFH0346.png') },
      { name: 'Kuwait Finance House', image: require('@/assets/images/fpx/KFH0346.png') },
      { name: 'Maybank2E', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'Maybank2U', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'Maybank', image: require('@/assets/images/fpx/MBB0228.png') },
      { name: 'OCBC Bank', image: require('@/assets/images/fpx/OCBC0229.png') },
      { name: 'Public Bank', image: require('@/assets/images/fpx/PBB0233.png') },
      { name: 'RHB Now', image: require('@/assets/images/fpx/RHB0218.png') },
      { name: 'RHB Bank', image: require('@/assets/images/fpx/RHB0218.png') },
      { name: 'Standard Chartered', image: require('@/assets/images/fpx/SCB0216.png') },
      { name: 'UOB Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      { name: 'United Overseas Bank', image: require('@/assets/images/fpx/UOB0226.png') },
      { name: 'PayPal', image: require('@/assets/images/fpx/Paypal.png') }
    ],
    banks: [],
    selectedBankIndex: null,
    isLoading: false,
    retryPaymentLoading: false
  }),
  watch: {
    accountType () {
      this.plans.forEach(p => {
        if (p.name === this.selectedPlan.name) {
          p.selected = true
          this.selectedPlan = p
        } else {
          p.selected = false
        }
      })
    },
    step: {
      immediate: true,
      handler (val) {
        this.$axios.patch(`/companies/${this.company.id}`, { extra_data: { 'campaign:promo1010.last_subscribe_modal_step': val }}).catch(() => {})
      }
    }
  },
  computed: {
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    totalAllowedMember () {
      return this.selectedPlan.member_count + this.memberAddOnCount
    },
    isValidMemberCount () {
      if (this.company.active_member_count > this.totalAllowedMember) {
        return false
      }
      return true
    },
    totalAllowedForm () {
      return this.selectedPlan.form_count + this.formAddOnCount
    },
    isValidFormCount () {
      if (this.selectedPlan.name == 'Intelligence') {
        return true
      }
      if (this.company.published_form_count > this.totalAllowedForm) {
        return false
      }
      return true
    },
    extraPrice () {
      let totalPrice = 0
      if (this.formAddOnCount) {
        totalPrice += this.formAddOnCount * 30
      }
      if (this.memberAddOnCount) {
        totalPrice += this.memberAddOnCount * 100
      }
      return totalPrice
    },
    extraPriceNormal () {
      let totalPrice = 0
      if (this.formAddOnCount) {
        totalPrice += this.formAddOnCount * 36
      }
      if (this.memberAddOnCount) {
        totalPrice += this.memberAddOnCount * 120
      }
      return totalPrice
    },
    totalPrice () {
      if (!this.selectedPlan) return 0
      let basePrice = this.selectedPlan.price
      return basePrice
    },
    totalPriceNormal () {
      if (!this.selectedPlan) return 0
      let basePrice = this.selectedPlan.normal_price
      return basePrice
    },
    totalPriceAmount () {
      if (!this.selectedPlan) return 0
      let totalPrice = this.extraPrice
      totalPrice += this.selectedPlan.price
      return totalPrice
    },
    formItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Personal') {
        return [0,1,2,3]
      } else if (this.selectedPlan.name == 'Business') {
        return [0,1,2,3,4]
      }
      return []
    },
    memberItems () {
      if (!this.selectedPlan) return []
      if (this.selectedPlan.name == 'Personal') {
        return [0,1,2,3]
      } else if (this.selectedPlan.name == 'Business') {
        return [0,1,2,3,4]
      }
      return []
    },
    windowTitle () {
      return this.steps[this.step].title
    },
    currentProgress () {
      return Math.ceil((this.step / this.steps.length) * 100)
    }
  },
  mounted () {
    if (this.payment) {
      if (this.payment.success) {
        this.step = 4
        this.$axios.patch(`/companies/${this.company.id}`, { extra_data: { 'campaign:promo1010.subscribe_success': `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.payment.billId}` }}).catch(() => {})
      } else {
        this.step = 5
        this.$axios.patch(`/companies/${this.company.id}`, { extra_data: { 'campaign:promo1010.payment_failed': `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.payment.billId}` }}).catch(() => {})
      }
    }

    this.fetchCompany()
    this.getSupportedBank()

    let index = 1
    if (this.company.published_form_count > this.plans[0].max.form) {
      index = 1
    }
    if (this.company.published_form_count > this.plans[1].max.form) {
      index = 2
    }
    if (this.company.active_member_count > this.plans[0].max.member) {
      index = 1
    }
    if (this.company.active_member_count > this.plans[1].max.member) {
      index = 2
    }
    this.plans[index].selected = true
    this.selectedPlan = this.plans[index]
    if (this.company.published_form_count - this.selectedPlan.form_count > 0 && index != 2) {
      this.formAddOnCount = this.company.published_form_count - this.selectedPlan.form_count
    }
    if (this.company.active_member_count - this.selectedPlan.member_count > 0) {
      this.memberAddOnCount = this.company.active_member_count - this.selectedPlan.member_count
    }
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    getSupportedBank() {
      this.$axios.get(`/banks/?gateway=billplz&active=true&staging=false`)
        .then((resp) => {
          resp.data.results.forEach(bank => {
            const selectedBank = this.bankImages.filter((obj) => {
              return obj.name.toLowerCase() == bank.name.toLowerCase()
            })
            bank['image'] = ''
            if (selectedBank.length != 0) {
              bank['image'] = selectedBank[0].image
            }
            this.banks.push(bank)
          })
        })
        .catch(() => {})
    },
    selectPlan(plan) {
      this.plans.forEach(p => {
        if (p.name === plan.name) {
          p.selected = true
          this.selectedPlan = p
          if (this.selectedPlan.name == 'Intelligence') {
            this.formAddOnCount = 0
          } else if (this.formAddOnCount > (this.selectedPlan.max.form - this.selectedPlan.form_count)) {
            this.formAddOnCount = this.selectedPlan.max.form - this.selectedPlan.form_count
          }
          if (this.selectedPlan.name != 'Intelligence' && this.memberAddOnCount > (this.selectedPlan.max.member - this.selectedPlan.member_count)) {
            this.memberAddOnCount = this.selectedPlan.max.member - this.selectedPlan.member_count
          }
        } else {
          p.selected = false
        }
      })
    },
    handleVerification() {
      this.step++
    },
    backStep () {
      if (this.step === 3 && !this.selectedPlan.extraInfoRequired) {
        this.step = 1
      } else if (this.step === 5) {
        this.step = 0
      } else {
        this.step--
      }
    },
    nextStep () {
      if (this.step === 1) {
        if (!this.isValidMemberCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_member_count')])
          return
        }
        if (!this.isValidFormCount) {
          this.showMessage(['error', this.$t('error_message.exceeded_form_count')])
          return
        }

        if (!this.selectedPlan.extraInfoRequired) {
          this.step = 3
          return
        }
      }
      if (this.step === this.steps.length - 1) return
      if (this.step === 2) {
        this.proceed++
      } else if (this.step === 3) {
        this.form.plan = this.selectedPlan.value
        this.isLoading = true
        this.form.extra_form = this.formAddOnCount
        this.form.extra_member = this.memberAddOnCount
        this.form.bank_code = this.banks[this.selectedBankIndex].code
        this.$axios.post(`/billing/contracts/one_year_promo_payment_request/`, this.form)
          .then(resp => {
            const data = resp.data
            this.$axios.patch(`/companies/${this.company.id}`, { extra_data: { 'campaign:promo1010.payment_initiated': data.bill_url }})
            setTimeout(() => {
              location.href = data.bill_url
            }, 1000)
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
            this.isLoading = false
          })
      } else {
        this.step++
      }
    },
    finish () {
      this.dialog = false
    },
    fetchCompany () {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios.get(`/companies/${this.company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      } else {
        this.$axios.get(`/companies/${this.$subdomain}/`, { params: { use_slug: 'true' } })
          .then(resp => {
            this.updateCompany(resp.data)
          })
          .catch(() => {})
      }
    },
    retryPayment () {
      this.retryPaymentLoading = true
      this.$axios.patch(`/companies/${this.company.id}`, { extra_data: { 'campaign:promo1010.failed_payment_retried': new Date() }}).catch(() => {})
      location.href = `${process.env.VUE_APP_BILLPLZ_URL}/bills/${this.payment.billId}?auto_submit=true`
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.totalPriceAmount
        })
      })
    },
    trackPixel () {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Subscribe', {
        value: this.totalPriceAmount/this.$currency.multiplier,
        currency: this.$currency.code
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid grey;
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}
</style>
